import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { userData, loading } = useAuth();

  // Pendant le chargement, afficher un écran de chargement au lieu du contenu
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
          <p className="mt-4 text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  // Si pas d'utilisateur connecté, rediriger vers la page de connexion
  if (!userData) {
    return <Navigate to="/login" replace />;
  }

  // Si l'utilisateur est connecté, afficher le contenu
  return children;
};

export default ProtectedRoute;
